"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var codemirror_1 = __importDefault(require("codemirror"));

var SearchResult_1 = require("../models/SearchResult");

var LanguageHints =
/** @class */
function () {
  function LanguageHints(strategy, options) {
    this.options = options;
    this.strategy = strategy;
  }

  LanguageHints.create = function (strategy, options) {
    return new LanguageHints(strategy, options);
  };

  LanguageHints.prototype.getStrategy = function () {
    var _this = this;

    return function (index, onShow, onHide) {
      return {
        completeSingle: false,
        hint: function hint(editor) {
          var searchResult = _this.strategy(editor, index, _this.options);

          var result = SearchResult_1.SearchResult.toCodeMirror(searchResult);

          var showCallback = function showCallback() {
            onShow(searchResult);
          };

          var hideCallback = function hideCallback() {
            codemirror_1.default.off(result, 'shown', showCallback);
            codemirror_1.default.off(result, 'close', hideCallback);
            onHide(searchResult);
          };

          codemirror_1.default.on(result, 'shown', showCallback);
          codemirror_1.default.on(result, 'close', hideCallback);
          return result;
        }
      };
    };
  };

  return LanguageHints;
}();

exports.LanguageHints = LanguageHints;